import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { getAllCorporateUsers } from '@/api/corporate/corporate.actions.ts';
import { CorporateSummaryData } from '@/api/corporate/corporate.types.ts';
import { isApiSuccess } from '@/api/shared.types.ts';
import { useAsync } from '@/hooks/global/useAsync.ts';

const DEFAULT_PAGE_SIZE = 10;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const useCorporateUsers = (pageSize = DEFAULT_PAGE_SIZE) => {
  const [corporateUsers, setCorporateUsers] = useState<CorporateSummaryData[]>(
    []
  );
  const [corporateCount, setCorporateCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const { run: runFetchAll, isLoading: isFetchingAll } = useAsync();

  const fetchCorporateUsers = async (page = 1): Promise<void> => {
    const response = await runFetchAll(() =>
      getAllCorporateUsers(page, pageSize)
    );

    if (isApiSuccess(response)) {
      setCorporateUsers(response.content.data);
      setCorporateCount(response.content.pagination.total);
      return;
    }

    toast.error(response.error.message);
    setCorporateUsers([]);
  };

  useEffect(() => {
    fetchCorporateUsers(currentPage);
  }, [currentPage]);

  return {
    corporateUsers,
    corporateCount,
    isFetchingAll,
    refetch: fetchCorporateUsers,
    pageSize,
    currentPage,
    setCurrentPage,
  };
};
